import { createTheme } from '@mui/material/styles';

/**
 * Scoped to LoginPage only (wrapped around <LoginPage> itself, not the app
 * root). Unlike src/pages/theme/landingTheme.ts — which only neutralizes
 * MUI's defaults so Tailwind className drives everything — this theme
 * carries real design tokens (palette/typography/shape), matching how the
 * app-wide theme in src/context/ThemeContext.tsx works. The new
 * components/common/mui/* atoms read these tokens via MUI's variant/color
 * props instead of repeating Tailwind size/color classes per instance.
 * Does not affect the app-wide MUI theme, which Ticket Management and
 * other screens still rely on.
 */
const loginTheme = createTheme({
  palette: {
    primary: {
      main: '#4F46E5', // indigo-600
      light: '#818CF8', // indigo-400
      dark: '#3730A3', // indigo-800
    },
    secondary: {
      main: '#9333EA', // purple-600
    },
    success: {
      main: '#059669', // emerald-600
      light: '#A7F3D0', // emerald-200
    },
    error: {
      main: '#E11D48', // rose-600
      light: '#FECDD3', // rose-200
    },
    background: {
      default: '#FFFFFF',
      paper: '#FFFFFF',
    },
  },
  shape: {
    borderRadius: 12,
  },
  typography: {
    fontFamily: '"Inter", ui-sans-serif, system-ui, -apple-system, "Segoe UI", Roboto, sans-serif',
    h1: { fontSize: '2.25rem', fontWeight: 700, lineHeight: 1.2, letterSpacing: '-0.02em' }, // 36px — left-panel brand name
    h2: { fontSize: '1.875rem', fontWeight: 700, lineHeight: 1.25 }, // 30px — card heading / tagline
    h3: { fontSize: '1.5rem', fontWeight: 700, lineHeight: 1.3 }, // 24px — mobile logo heading
    body1: { fontSize: '1rem', fontWeight: 400, lineHeight: 1.5 }, // 16px — subheading/paragraph baseline
    body2: { fontSize: '0.875rem', fontWeight: 400, lineHeight: 1.5 }, // 14px — labels, testimonial, brand subline
    caption: { fontSize: '0.75rem', fontWeight: 400, lineHeight: 1.5 }, // 12px — footer, captions
  },
  components: {
    MuiTypography: {
      styleOverrides: {
        root: {
          margin: 0,
        },
      },
    },
  },
});

export default loginTheme;
